import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../../constants/actionTypes";
import * as Tools from "../../../helpers/Tools";
import { logUI } from '../../../api/andyliticsApi';
import { Tooltip } from 'reactstrap';
import moment from 'moment-timezone';
import { Modal, ModalBody } from 'reactstrap';

class AABenefits extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            copays: { InNetwork: null, OutOfNetwork: null },
            currentMember: null,
            longestFootnote: null,
            shouldRetrieveData: true,
            showTooltip: false,
        };
        this.setCopayData = this.setCopayData.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AABenefitsPlan.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { isFetching } = this.props;

        if (this.props.benefitDetails && (this.props.benefitDetails !== prevProps.benefitDetails || this.props.benefitError !== prevProps.benefitError)) {
            this.setState({ showLoader: false });
            if (this.props.benefitDetails !== prevProps.benefitDetails) {
                this.setCopayData(this.props.benefitDetails.LineItems);
            }
        }

        if (this.props.AA && this.state.shouldRetrieveData && !isFetching) {
            this.setState({ shouldRetrieveData: false });
            this.props.getPlan(this.props.AA);
        }
    }

    setCopayData(lineItems) {
        if (!lineItems || lineItems.length <= 0) return;
        let longestCopay;
        let copayObject = { InNetwork: [], OutOfNetwork: [] };
        lineItems.map(item => {
            if (item.SectionName === "Copays") {
                if (item.TierLevel === "In-Network") {
                    copayObject.InNetwork.push(item);
                } else if (item.TierLevel === "Out-Of-Network") {
                    copayObject.OutOfNetwork.push(item);
                }

                if (!longestCopay || item.Footnotes.length > longestCopay.Footnotes.length) {
                    longestCopay = item;
                }
            }
        });

        let footnoteArray = "[" + longestCopay.Footnotes + "]";
        footnoteArray = JSON.parse(footnoteArray);
        this.setState({ copays: copayObject, longestFootnote: footnoteArray });
    }

    toggleTooltip() {
        this.setState({ showTooltip: !this.state.showTooltip });
    }

    render() {
        return (
            <div className="container-fluid body-content hp hp-benefits-container">
                <div className="row">
                    <div className="col-12">
                        <div className="hp-title maxWidth-content">
                            Plan
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12">
                        <div className="sub-header maxWidth-content">
                            <div className="row no-gutters align-items-mobile aa-benefits-plan-title">
                                <div>
                                    <span className="bold-text sub-header-label">Plan Name: </span>
                                    {this.props.benefitDetails ? this.props.benefitDetails.PlanDisplayName : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12">
                        {this.state.showLoader
                            ?
                            <div className="spinner">
                                <div className="bounce1" />
                                <div className="bounce2" />
                                <div className="bounce3" />
                            </div>
                            :
                            <div className="benefit-page">
                                <div className="row">
                                    <div className="col-12 maxWidth-content">
                                        <div>
                                            <div className="row no-gutters copays-container">
                                                <div className="semi-bold-text copays-title">
                                                    <div>
                                                        In-Network Copays
                                                <span className="icon-question info-hover">
                                                            <div className="info-hover-content">A copayment (copay) is a fixed amount you pay either for a covered health service at time of visit, or for a medication included in your prescription drug plan.</div>
                                                        </span>
                                                    </div>
                                                    <div className="barely-bold-text copays-sub-title">DUE AT THE TIME OF SERVICE</div>
                                                </div>
                                            </div>
                                            <div className="row no-gutters copays-container">
                                                <div className="col-xl-6">
                                                    {this.state.copays.InNetwork && this.state.copays.InNetwork.length > 0
                                                        ?
                                                        <div className="copay-list">
                                                            {this.state.copays.InNetwork.map((item, key) => {
                                                                return (
                                                                    <div className="copay-line-item" key={`copay-in-${key}`}>
                                                                        <div className="bold-text copay-label">{item.LineItemName}</div>
                                                                        <div className="push-right semi-bold-text copay-value">{item.Amount}</div>
                                                                        <div className="copay-footnote-label" style={{ width: `${this.state.longestFootnote.length * 10}px` }}>{item.Footnotes}</div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        :
                                                        ""
                                                    }
                                                </div>
                                                <div className="col-xl-6 footnote-explanation-wrapper">
                                                    <div className="footnote-explanation-container">
                                                        {this.props.benefitDetails.Footnotes && this.props.benefitDetails.Footnotes.length > 0
                                                            ?
                                                            this.props.benefitDetails.Footnotes.map((footnote, key) => {
                                                                return (
                                                                    <div className="footnote-line" key={`footnote-line-${key}`}>
                                                                        <div className="copay-footnote-label">{footnote.FootnoteID}</div>
                                                                        <div className="copay-footnote-description" dangerouslySetInnerHTML={{ __html: footnote.FootnoteText }}></div>
                                                                    </div>
                                                                );
                                                            })
                                                            :
                                                            ""
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    this.props.benefitDetails.LineItems && this.props.benefitDetails.LineItems.length > 0 && this.props.benefitDetails.LineItems.find(item => item.SectionName !== "Copays")
                                        ?
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="eoc-container">
                                                    <div className="semi-bold-text eoc-title">Explanation of Coverage</div>

                                                    <div className="eoc-list">
                                                        {this.props.benefitDetails.LineItems.map((item, key) => {
                                                            if (item.SectionName === "Copays") return;
                                                            let footnote = item.Footnotes !== "" ? this.props.benefitDetails.Footnotes.find(element => element.FootnoteID === item.Footnotes) : null;
                                                            return (
                                                                <div className="row no-gutters eoc-line-item" key={`eoc-item-${key}`}>
                                                                    <div className="eoc-accordion eoc-accordion-header">
                                                                        <div className="col-12 col-sm-7 eoc-header-title">
                                                                            {item.LineItemName}
                                                                            {item.Footnotes !== "" && footnote
                                                                                ?
                                                                                <div className="eoc-footnote">{footnote.FootnoteText}</div>
                                                                                :
                                                                                ""
                                                                            }
                                                                        </div>
                                                                        <div className="col-12 col-sm-5 semi-bold-text eoc-amount-covered">{item.Amount}</div>
                                                                    </div>
                                                                    {item.Footnotes !== "" && footnote
                                                                        ?
                                                                        <div className="eoc-footnote tablet-view ">{footnote.FootnoteText}</div>
                                                                        :
                                                                        ""
                                                                    }
                                                                </div>
                                                            );
                                                        })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>

        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        benefitDetails: state.healthPlanServices.planDetail,
        benefitError: state.healthPlanServices.error,
        AA: state.domain.aai,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPlan: (memberId) => dispatch({ type: types.HP_GET_BENEFIT_PLAN_DETAIL_START, memId: memberId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AABenefits));